import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {MenuController} from '@ionic/angular';
import {UserService} from '../../../services/customer/user.service';
import {CompetitionService} from '../../../services/customer/competition.service';
import {CategoryService} from '../../../services/customer/category.service';

interface CustomerMenuItem {
  Title: string;
  Path: string[];
  Icon?: string;
  IconSrc?: string;
  Visible?: () => boolean;
}

/**
 * Content of the side menu of the customers (right): the entries of the former menu page (/navigation). The
 * ion-menu itself is in app.component.html, it is active outside of the administration and opened by the menu
 * button of the header. The entries depending on the user are loaded, when the menu opens.
 */
@Component({
  selector: 'app-customer-side-menu',
  templateUrl: './customer-side-menu.component.html',
  styleUrls: ['./customer-side-menu.component.scss'],
})
export class CustomerSideMenuComponent {

  static readonly MENU_ID = 'customer-menu';

  adminFlag = false;
  showCompetitions = false;
  hasRecipes = true;

  readonly items: CustomerMenuItem[] = [
    { Title: 'Startseite', Path: ['/product-category-list'], IconSrc: 'assets/icons/kiwi-logo.svg' },
    { Title: 'Profil', Path: ['/profile'], IconSrc: 'assets/icons/kiwi-user.svg' },
    { Title: 'Lieferadressen', Path: ['/profile', 'address-list'], IconSrc: 'assets/icons/kiwi-marker.svg' },
    { Title: 'Suchen', Path: ['/search-detail'], IconSrc: 'assets/icons/kiwi-search.svg' },
    { Title: 'Rezepte', Path: ['/recipe-category-list'], IconSrc: 'assets/icons/kiwi-chef.svg', Visible: () => this.hasRecipes },
    { Title: 'Favoriten', Path: ['/favorite'], IconSrc: 'assets/icons/kiwi-heart.svg' },
    { Title: 'Warenkorb', Path: ['/cart'], IconSrc: 'assets/icons/kiwi-cart.svg' },
    { Title: 'Gewinnspiele', Path: ['/competition-list'], Icon: 'gift-outline', Visible: () => this.showCompetitions },
    { Title: 'Zuletzt gekauft', Path: ['/order-detail', 'latest'], IconSrc: 'assets/icons/kiwi-bag.svg' },
    { Title: 'Bestellübersicht', Path: ['/order-list'], IconSrc: 'assets/icons/kiwi-paper.svg' },
    { Title: 'Einstellungen', Path: ['/setting'], IconSrc: 'assets/icons/kiwi-cog.svg' },
    { Title: 'Administration', Path: ['/admin'], Icon: 'key-outline', Visible: () => this.adminFlag }
  ];

  constructor(
    private router: Router,
    private menuController: MenuController,
    private userService: UserService,
    private competitionService: CompetitionService,
    private categoryService: CategoryService
  ) { }

  get visibleItems(): CustomerMenuItem[] {
    return this.items.filter(item => !item.Visible || item.Visible());
  }

  // called when the menu opens: role, competitions and recipes of the current user
  async load() {
    try {
      this.adminFlag = await this.userService.hasRole();
    } catch (e) {
      this.adminFlag = false;
    }
    try {
      this.showCompetitions = await this.competitionService.getVisible();
    } catch (e) {
      this.showCompetitions = false;
    }
    try {
      const categories = await this.categoryService.getAllRecipeCategories();
      this.hasRecipes = !!categories?.length;
    } catch (e) {
    }
  }

  isSelected(item: CustomerMenuItem): boolean {
    const path = item.Path.join('/').replace('//', '/');
    const url = this.router.url || '';
    return url === path || url.startsWith(path + '/') || url.startsWith(path + '?');
  }

  async open(item: CustomerMenuItem) {
    await this.menuController.close(CustomerSideMenuComponent.MENU_ID);
    return this.router.navigate(item.Path);
  }
}
